/** Permission keys — must match API `permissions[].key` and route/nav `permissionKey`. */
export const subadminsKey = 'subadmins'
export const subadminRolesKey = 'subadminRoles'
export const adminRolesKey = subadminRolesKey
export const vendorRolesKey = 'vendor-roles'
export const informationPolicyKey = 'informationPolicy'
export const cartKey = 'cart'
export const productsKey = 'products'
export const categoriesKey = 'categories'
export const pagesKey = 'Pages'
export const bannerKey = 'banners'
export const bookingsKey = 'bookings'
export const paymentsKey = 'payments'
export const widgetsKey = 'widgets'
export const adminSettingsKey = 'adminSettings'
export const clientsKey = 'clients'
export const seoKey = 'seo'
export const configSettingsKey = 'configSettings'
export const templateKey = 'template'
export const couponsKey = 'coupons'
export const visitorType = 'visitorType'
export const locationKey = 'location'
export const cancellationRequest = 'cancellation'
export const listingKey = 'listings'
export const districtKey = 'district'
export const stateKey = 'state'
export const countryKey = 'country'
export const pincodeKey = 'pincode'
export const cityKey = 'city'
export const brandKey = 'brand'
export const categoryKey = 'category'
export const userKey = 'user'
export const ratingKey = 'rating'
export const notificationKey = 'notificationKey'
export const deliveryZoneKey = 'delivery-zones'
export const ordersKey = 'orders'
export const returnKey = 'return'
export const contactUsKey = 'contact-us'
export const collectionKey = 'collection'
export const tagKey = 'tags'
export const taxCategoryKey = 'tax-category'
export const designationKey = 'designation'
export const vendorEmployeeKey = 'vendor-employee'
export const vendorsKey = 'vendors'
export const affiliateRequestsKey = 'affiliate-requests'
export const affiliateTransactionsKey = 'affiliate-transactions'
export const salesReportKey = 'sales-report'
export const filterTagKey = 'filter-tags'
export const documentsKey = 'documents'
export const usersKey = 'users'
export const partnersKey = 'Partners'
export const brandsKey = 'brands'
export const departmentsKey = 'departments'
export const careersKey = 'careers'
export const careerApplicationsKey = 'CareerApplication'
export const ourTeamKey = 'OurTeam'
export const projectsKey = 'Projects'
